// @flow
import { Box, useTheme } from '@mui/material';
import * as React from 'react';

/**
 * PEP Status Icons
 * 
 * @param props
 * @return {XML}
 */
const PepStatus = (props) => {
  const theme = useTheme();
  const { status, size = '24px', style, title, ...rest } = props;
  const purple = theme.palette.purple.main;
  const grey = '#bdbdbd';

  // PEP identified: solid purple border, transparent background, purple P
  if (status === 'identified') {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          border: `1.5px solid ${purple}`,
          backgroundColor: 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '15px',
          color: purple,
          fontWeight: 700,
        }}
        style={style}
        title={title}
        {...rest}
      >
        P
      </Box>
    );
  }

  // Not PEP: solid grey border, transparent background, grey P
  if (status === 'not_pep') {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          border: `1.5px solid ${grey}`,
          backgroundColor: 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '15px',
          color: grey,
          fontWeight: 700,
          opacity: 0.8,
        }}
        style={style}
        title={title}
        {...rest}
      >
        <span>P</span>
      </Box>
    );
  }

  return null;
};

export default PepStatus; 